'use client';

import * as React from 'react';

import { cn } from '../../utils/cn/cn';
import { Notification } from '../Notification/Notification';

export interface RadioGroupProps {
  children: React.ReactNode;
  id?: string;
  label?: string;
  className?: string;
  error?: boolean;
  notificationText?: React.ReactNode;
}

export const RadioGroup = ({
  children,
  className,
  label,
  error,
  notificationText,
  id,
}: RadioGroupProps) => (
  <fieldset id={id} className={cn('grid gap-0.5', className)}>
    {label && (
      <legend className="text-color-text text-size-body-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-35">
        {label}
      </legend>
    )}
    {children}
    {notificationText && (
      <Notification severity={error ? 'error' : 'info'} variant="feedback">
        {notificationText}
      </Notification>
    )}
  </fieldset>
);
